import { DecimalPipe } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS } from '@angular/material-luxon-adapter';
import { HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { PreloadAllModules, provideRouter, withInMemoryScrolling, withPreloading } from '@angular/router';

import { NgIdleModule } from '@ng-idle/core';
import { provideGoogleTagManager } from 'angular-google-tag-manager';
import { provideToastr } from 'ngx-toastr';

import { environment } from 'environments/environment';

import { provideAuth } from './core/auth/auth.provider';
import { provideIcons } from './core/icons/icons.provider';
import { appRoutes } from './app.routing';
import { CustomHammerConfig } from './gesture.config';

export const appConfig: ApplicationConfig = {
	providers: [
		DecimalPipe,
		{
			provide: LOCALE_ID,
			useValue: 'en-AU',
		},
		provideAnimations(),
		provideHttpClient(),
		provideAuth(),
		provideRouter(
			appRoutes,
			withPreloading(PreloadAllModules),
			withInMemoryScrolling({ scrollPositionRestoration: 'enabled' }),
		),
		{
			provide: LOCALE_ID,
			useValue: 'en-AU',
		},
		{
			provide: DateAdapter,
			useClass: LuxonDateAdapter,
			deps: [MAT_DATE_LOCALE, MAT_LUXON_DATE_ADAPTER_OPTIONS],
		},
		{
			provide: MAT_DATE_FORMATS,
			useValue: {
				parse: {
					dateInput: 'D',
				},
				display: {
					dateInput: 'DDD',
					monthYearLabel: 'LLL yyyy',
					dateA11yLabel: 'DD',
					monthYearA11yLabel: 'LLLL yyyy',
				},
			},
		},
		provideIcons(),
		provideToastr({
			positionClass: 'toast-bottom-right',
			progressBar: true,
			timeOut: 5000,
		}),
		importProvidersFrom(NgIdleModule.forRoot()),
		{
			provide: ErrorHandler,
		},
		importProvidersFrom(HammerModule),
		{ provide: HAMMER_GESTURE_CONFIG, useClass: CustomHammerConfig },
		provideGoogleTagManager({
			id: environment.googleTagMangerId,
			gtm_auth: environment.googleTagMangerAuth,
		}),
	],
};
